import { IMAGES, LINKS, CONTENT } from "../../const/config";
import { AndroidIcon, AppleIcon, InfoItem, PlatformDownload } from "../../components/home/Index";
import Footer from "../../components/Footer";
import { useStoreLinks } from "../../hooks/useStoreLinks";

export default function DesktopView() {
  const { links: storeLinks } = useStoreLinks();

  const androidData = {
    directLink: LINKS.android.direct,
    storeLink: storeLinks.android,
  };

  const iosData = {
    directLink: LINKS.ios.direct,
    storeLink: storeLinks.ios,
  };

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {/* ── Header ── */}
      <header className="w-full text-center pt-6 pb-3 px-4">
        <h1 className="text-3xl font-bold text-blue-600 tracking-tight">
          {CONTENT.header.title}
        </h1>
        <p className="text-gray-400 text-sm mt-1.5">
          {CONTENT.header.subtitle}
        </p>
      </header>

      {/* ── Centered content ── */}
      <main className="flex-1 w-full max-w-2xl mx-auto px-6 pb-6">
        <div className="flex flex-col items-center text-center">

          {/* Hero image */}
          <div className="overflow-hidden mb-4 p-4 shadow-sm rounded-lg bg-blue-600 flex justify-center items-center">
            <img
              src={IMAGES.logo}
              alt="App preview"
              className="w-auto h-24 object-contain"
            />
          </div>

          {/* Info items */}
          <div className="w-full space-y-1">
            {CONTENT.features.map((feature, i) => (
              <InfoItem key={i} value={feature.value} sub={feature.sub} />
            ))}
          </div>

          {/* Download section */}
          <div className="mt-5 w-full">
            <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider mb-3">
              {CONTENT.labels.downloadApp}
            </p>
            <div className="flex gap-6 justify-center items-stretch">
              <PlatformDownload
                icon={<AndroidIcon />}
                title="Android"
                {...androidData}
              />
              <div className="w-px bg-gray-200 self-stretch my-2" />
              <PlatformDownload
                icon={<AppleIcon />}
                title="iOS"
                {...iosData}
              />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
